/**
 * Tripjack raw-response helper for the FlightCard / BookingDetails UI.
 *
 * Wave 6 R4 added `oB` (operating airline) to Tripjack v2.0. This helper
 * surfaces it as "Operated by {carrier}" so travellers know the actual
 * flying airline on codeshare segments (e.g., AI marketed / IX operated).
 *
 * Note: supplier/inventory-source (LCC/GDS/NDC) is intentionally NOT
 * surfaced to the UI — it's operational info that only confuses end users.
 */

/**
 * Extract operating-carrier codeshare info from a Tripjack segment's fD.oB.
 * Returns `null` fields when `oB` is absent or matches the marketing carrier.
 * @param {Object} fD - fD (flight data) of a segment
 * @returns {{ operatingAirline: string|null, operatingAirlineCode: string|null, isCodeshare: boolean }}
 */
export const deriveCodeshare = (fD) => {
  if (!fD) return { operatingAirline: null, operatingAirlineCode: null, isCodeshare: false };
  const oB = fD.oB || null;
  const marketedCode = fD.aI && fD.aI.code;
  if (!oB) return { operatingAirline: null, operatingAirlineCode: null, isCodeshare: false };
  const opName = typeof oB === 'string' ? null : (oB.name || null);
  const opCode = typeof oB === 'string' ? oB : (oB.code || null);
  if (!opCode) return { operatingAirline: null, operatingAirlineCode: null, isCodeshare: false };
  return {
    operatingAirline: opName,
    operatingAirlineCode: opCode,
    isCodeshare: !!marketedCode && opCode !== marketedCode,
  };
};
